import { LegalLayout, LegalSection } from "./LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" updated="September 2026" testId="privacy-page">
      <LegalSection heading="1. What We Collect">
        <p>
          When you use brandijo.com, we collect only what you give us: your name, email address, phone
          number (if you opt into texts), and any message you send through our contact or signup forms.
          We also collect standard technical data (such as browser type) needed to operate the Site.
        </p>
      </LegalSection>
      <LegalSection heading="2. How We Use It">
        <p>
          We use your information to respond to your inquiries, deliver digital products you purchase,
          send newsletters or text messages you opted into, and provide coaching services you engage. We
          do not use your information for purposes unrelated to what you requested.
        </p>
      </LegalSection>
      <LegalSection heading="3. Text Messaging Privacy">
        <p>
          If you opt in to receive text messages, your consent and mobile information are used solely to
          send you the messages you requested. <strong className="text-brand-mist">Mobile opt-in data and consent are never shared with,
          sold to, or transferred to third parties for marketing or promotional purposes.</strong> Reply STOP at
          any time to stop receiving messages and HELP for help.
        </p>
      </LegalSection>
      <LegalSection heading="4. Sharing">
        <p>
          We do not sell your personal information. We share it only with service providers who help us
          operate the Site (such as hosting, email, payment, and messaging platforms), and only as needed
          to deliver what you requested, or where required by law.
        </p>
      </LegalSection>
      <LegalSection heading="5. Retention and Security">
        <p>
          We keep your information only as long as needed for the purposes above and protect it with
          reasonable technical and organizational safeguards. No method of transmission or storage is
          100% secure, but we work to protect your data.
        </p>
      </LegalSection>
      <LegalSection heading="6. Your Choices">
        <p>
          You may unsubscribe from emails via the link in any email, stop texts by replying STOP, and
          request access to or deletion of your personal information at any time by emailing{" "}
          <a href="mailto:me@brandijo.com" className="underline hover:text-brand-gold transition-colors">me@brandijo.com</a>.
        </p>
      </LegalSection>
      <LegalSection heading="7. Third-Party Sites">
        <p>
          Links to third-party websites (including payment and scheduling providers) are governed by
          those parties' own privacy policies. Some links may be affiliate links, disclosed where they
          appear.
        </p>
      </LegalSection>
      <LegalSection heading="8. Changes and Contact">
        <p>
          We may update this policy from time to time; the "Last updated" date reflects the current
          version. Questions or requests:{" "}
          <a href="mailto:me@brandijo.com" className="underline hover:text-brand-gold transition-colors">me@brandijo.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
